import type { CasinoProviderGame } from '~/types/game'

export interface CasinoProviderStore {
  data: CasinoProviderGame[]
}

export const casinoProviderStore = defineStore('casinoProvider', {
  state: (): CasinoProviderStore => ({
    data: [],
  }),
  persist: false,
  actions: {
    setCasinoProvider(providers: CasinoProviderGame[]) {
      this.data = providers
    },
    getCasinoProvider(): CasinoProviderGame[] {
      return this.data
    },
    resetCasinoProvider() {
      this.data = []
    },
  },
})
